module.exports = __webpack_public_path__ + "static/media/report-warning-icon.bc35d02c.svg";